import { queryClient } from 'App';

import { appointmentQueryKeys } from 'lib/constants/constants';

export default async (data) => {
  const { appointment, invalidate } = data;

  appointmentQueryKeys.forEach((key) => {
    queryClient.invalidateQueries({
      queryKey: [key],
      exact: false
    });
  });
  if (invalidate) return;

  queryClient.setQueryData(['appointmentv2', appointment?.id], (oldData) => {
    if (!oldData) return;
    return {
      ...oldData,
      appointment: { ...(oldData?.appointment || {}), ...appointment }
    };
  });
};
